import {Component, Input, Output, EventEmitter} from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'priority-component',
    templateUrl: 'priority.component.html'
})
export class PriorityComponent {
    control = new FormControl();
    options = [
        {
            title: 'High',
            icon: true,
            color: 'red',
            value: 0
        },
        {
            title: 'Normal',
            icon: false,
            value: 1
        },
        {
            title: 'Low',
            icon: true,
            color: 'blue',
            value: 2
        }
    ];

    @Input() canEdit;
    @Input() listOnly;
    @Input() value;
    @Output() valueChange = new EventEmitter();

    constructor() {
        this.control.valueChanges.subscribe(value => {
            this.value = value;
            this.valueChange.emit(this.value);
        });
    }
}


// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/src/swarm/src/app/fields/priority.component.ts